module.exports = __webpack_public_path__ + "img/global-2018-developing-countries.d090a46a.jpg";